import { showAlert } from '../components/general-components/alert-service';
import { ChannelAuthMethod } from '../stores/types/types';
import { UpdatePresenterAuth } from './auth';
import { getHeaders } from './utils';

export const CheckInvitation = (token: string, code: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/check-invitation`, {
	method: 'POST',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		invitation: code,
	}),
}).then((result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	console.log(`${process.env.REACT_APP_API_HOST}/v2/greenroom/check-invitation status ${result.status}`);
	return false;
});

export const CheckSession = (token: string, session: number) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/check-session/${session}`, {
	method: 'GET',
	headers: getHeaders(token) as any,
}).then((result) => {
	if (result.ok) {
		return result.json();
	}
	return false;
});

// eslint-disable-next-line camelcase
export const CreateSession = (token: string, meeting: string, invitation: string, display_name: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/create-session`, {
	method: 'POST',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		meeting,
		invitation,
		// eslint-disable-next-line camelcase
		display_name,
	}),
}).then((result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/check-invitation status ${result.status}`);
});

export const GetInvitationsForPresenter = (token: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/presenter-invitations`, {
	method: 'GET',
	headers: getHeaders(token) as any,
}).then((result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/presenter-invitations status ${result.status}`);
});

export const CheckInvitationForUser = (id: number | string, token: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/check-user-invitation`, {
	method: 'POST',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		meeting: id,
	}),
}).then(async (result) => {
	if (result.ok) return result.json();
	return false;
});

// eslint-disable-next-line camelcase
export const ToggleInvitationType = (token: string, code: string, watcher_only: boolean) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/toggle-invitation-type`, {
	method: 'PUT',
	headers: getHeaders(token) as any,
	body: JSON.stringify({
		code,
		// eslint-disable-next-line camelcase
		watcher_only,
	}),
}).then(async (result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/toggle-invitation-type ${result.status}`);
});

export const GetTextLink = (phone: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/text-link`, {
	method: 'POST',
	headers: getHeaders('') as any,
	body: JSON.stringify({
		phone,
	}),
}).then(async (result) => result.ok);

export const GetEmailLink = (email: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/email-link`, {
	method: 'POST',
	headers: getHeaders('') as any,
	body: JSON.stringify({
		email,
	}),
}).then(async (result) => result.ok);

export const GetPasscode = (token: string, meeting: number) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/passcode/${meeting}`, {
	method: 'PUT',
	headers: getHeaders(token) as any,
}).then(async (result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/passcode/${meeting} ${result.status}`);
});

export const DisposePasscode = (token: string, passcode: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/passcode/${passcode}`, {
	method: 'DELETE',
	headers: getHeaders(token) as any,
}).then(async (result) => {
	if (result.status !== 200) {
		return true;
	}
	return false;
}).catch((e) => {
	console.error(e);
});

export const CheckPasscode = (passcode: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/passcode/${passcode}`, {
	method: 'GET',
	headers: getHeaders('') as any,
}).then(async (result) => {
	if (result.ok) {
		const json = result.json();
		return json;
	}
	throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/passcode/${passcode} ${result.status}`);
});

interface AuthorizationResponse {
	code: string;
}

export interface UpdateInvitationResponse {
	invitationCode: string;
	isWatcherOnly: boolean | null;
	authType: ChannelAuthMethod | null;
}

export const UpdateInvitation = async (
	token: string,
	invitationCode: string,
	isWatcherOnly: boolean,
	platformProfileId: number,
	channelId: number,
	authType: ChannelAuthMethod,
	showAuthError: boolean = true,
): Promise<UpdateInvitationResponse> => {
	// Update Platform auth method and Greenroom presenter type
	const [authentication, authorization] = await Promise.all([
		UpdatePresenterAuth(token, platformProfileId, channelId, authType),
		ToggleInvitationType(token, invitationCode, isWatcherOnly),
	]);

	if (showAuthError && authentication?.authType !== authType) {
		showAlert({
			message: 'Failed to update presenter authentication type',
			description: 'Please try again.',
			duration: 4000,
			type: 'error',
		});
	}

	return {
		invitationCode,
		isWatcherOnly: (authorization as AuthorizationResponse | undefined)?.code
			? isWatcherOnly
			: null,
		authType: authentication?.authType || null,
	};
};
